<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Search...">
<path id="Squircle" d="M0.75 9.08696C0.75 12.5495 1.36987 14.5512 2.58582 15.7237C3.80822 16.9025 5.817 17.4239 9.08696 17.4239C12.3569 17.4239 14.3657 16.9025 15.5881 15.7237C16.804 14.5512 17.4239 12.5495 17.4239 9.08696C17.4239 5.62441 16.804 3.62274 15.5881 2.45022C14.3657 1.27147 12.3569 0.750006 9.08696 0.750006C5.817 0.750006 3.80822 1.27147 2.58582 2.45022C1.36987 3.62274 0.75 5.62441 0.75 9.08696Z" stroke="#212135" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector 163" d="M18.1739 18.1739L16.1086 16.1087" stroke="#212135" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>

</template>